import React from "react";

const Contact: React.FC = () => {
    const contacts = [
        {
            name: "Telegram",
            icon: (
                <svg
                    className="w-8 h-8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" />
                </svg>
            ),
            url: "https://t.me/lacoste_33c",
            color: "from-sky-400 to-blue-500",
        },
        {
            name: "Telegram Canal",
            icon: (
                <svg
                    className="w-8 h-8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" />
                </svg>
            ),
            url: "https://t.me/+Ng6Vni7MbP40NzU0",
            color: "from-blue-700 to-indigo-800",
        },
        {
            name: "Snapchat",
            icon: (
                <svg
                    className="w-8 h-8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M12 2C7 2 4 5.5 4 10v6l-2 3c-.3.5 0 1 .5 1h3.5c.5 1.5 2 3 6 3s5.5-1.5 6-3h3.5c.5 0 .8-.5.5-1l-2-3v-6c0-4.5-3-8-8-8z" />
                </svg>
            ),
            url: "https://www.snapchat.com/add/lacoste_33c",
            color: "from-yellow-400 to-yellow-300",
            iconColor: "text-white",
            textColor: "text-black",
        },
    ];

    return (
        <div className="min-h-screen py-20 px-4 relative">
            {/* Background image */}
            <div className="fixed inset-0 overflow-hidden">
                <div style={{
                    position: "absolute", inset: 0,
                    backgroundImage: "url('/bg.png')",
                    backgroundSize: "cover", backgroundPosition: "center",
                }}></div>
            </div>
            {/* Background overlay with opacity */}
            <div className="fixed inset-0 bg-primary-dark/85"></div>

            <div className="max-w-4xl mx-auto relative z-10">
                {/* Header */}
                <div className="text-center mb-16">
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                        Contactez-nous
                    </h1>
                    <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                        Choisissez votre methode de communication preferee. Nous
                        sommes disponibles 24/7.
                    </p>
                </div>

                {/* Contact Buttons */}
                <div className="flex flex-col items-center space-y-6">
                    {contacts.map((contact) => (
                        <a
                            key={contact.name}
                            href={contact.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`w-full max-w-md card p-6 flex items-center justify-center space-x-4
                bg-gradient-to-r ${contact.color} hover:scale-105 transition-all duration-300
                border-none shadow-lg hover:shadow-xl`}
                        >
                            <span className={contact.iconColor || contact.textColor || "text-white"}>
                                {contact.icon}
                            </span>
                            <span
                                className={`text-xl font-semibold ${contact.textColor || "text-white"}`}
                            >
                                {contact.name}
                            </span>
                        </a>
                    ))}
                </div>

                {/* Info Section */}
                <div className="mt-16 text-center">
                    <div className="card p-8 max-w-2xl mx-auto">
                        <h2 className="text-2xl font-semibold text-white mb-4">
                            Informations
                        </h2>
                        <ul className="text-gray-300 space-y-3 text-left">
                            <li className="flex items-start space-x-3">
                                <svg
                                    className="w-5 h-5 text-accent mt-0.5 flex-shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span>Réponse garantie sous 20 min</span>
                            </li>
                            <li className="flex items-start space-x-3">
                                <svg
                                    className="w-5 h-5 text-accent mt-0.5 flex-shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span>
                                    Communication chiffree de bout en bout
                                </span>
                            </li>
                            <li className="flex items-start space-x-3">
                                <svg
                                    className="w-5 h-5 text-accent mt-0.5 flex-shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span>Discretion absolue assuree</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
